import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../components/isLoading";
import BlogsTableContainer from "../TableContainer";
import formatBlogs from "../../../helpers/formatBlog";
import { fetchNewslettersData } from "../../../redux/newsletter/index";
import { Button } from "@mui/material";
import { NavLink } from "react-router-dom";

export default () => {
	const newslettersData = useSelector((state) => state.newslettersGlobalStore);

	const dispatch = useDispatch();

	const [dataState, setDataState] = useState({
		formattedBlogsData: [],
		authorRecords: [],
		currentPage: 0,
	});

	useEffect(() => {
		dispatch(fetchNewslettersData(dataState.currentPage));
	}, [dataState.currentPage]);

	let formattedBlogsData = [];

	useEffect(() => {
		for (const newsletter of newslettersData.data?.data || []) {
			formattedBlogsData.push(formatBlogs(newsletter, "newsletters-stories"));
		}

		setDataState({ ...dataState, formattedBlogsData });
	}, [newslettersData.data]);

	const onPageChange = (pageNumber) =>
		setDataState((prevState) => ({ ...prevState, currentPage: pageNumber }));

	return (
		<div>
			{newslettersData.loading && !newslettersData.data[0] ? (
				<Loading />
			) : (
				<>
					<div
						style={{
							padding: "15px",
							float: "right",
						}}
					>
						<Button
							variant="outlined"
							component={NavLink}
							to="/newsletters/new"
							sx={{
								color: "#E00186",
								border: "1px solid #E00186",
								fontFamily: "Arial",
								"&:hover": {
									color: "#fff",
									backgroundColor: "#E00186",
									border: "1px solid #E00186",
								},
							}}
						>
							Add new Newsletter
						</Button>
					</div>
					<BlogsTableContainer
						headCells={[
							{ id: "title", rightAlign: false, label: "Title" },
							{ id: "status", rightAlign: true, label: "Status" },
							{ id: "author", rightAlign: true, label: "Author" },
							{ id: "postDate", rightAlign: true, label: "Posted" },
							{
								id: "updated",
								rightAlign: true,
								label: "Last update",
								doNotShowInMobile: true,
							},
						]}
						isUpdating={newslettersData.loading && newslettersData.data[0]}
						formattedData={dataState.formattedBlogsData}
						hidden={["category"]}
						title="All Newsletters"
						pagination={newslettersData.data.pagination || {}}
						onPageChange={onPageChange}
					/>
				</>
			)}
		</div>
	);
};
